export var PeoplePickerItemStyles = function PeoplePickerItemStyles(props) {
  var selected = props.selected,
      theme = props.theme;
  var palette = theme.palette;
  return {
    removeButton: [{
      background: 'transparent',
      selectors: {
        ':active': {
          color: palette.white,
          backgroundColor: palette.themeDark
        }
      }
    }, !selected && {
      color: palette.neutralPrimary
    }, selected && {
      color: palette.white
    }]
  };
};